import React from "react";
import {schemaMatches} from "@jsonforms/core";
import {withJsonFormsControlProps} from "@jsonforms/react";
import {TextField} from "@mui/material";
import {useTranslation} from "react-i18next";
import {RENDERER_TYPES} from "../constants";

export const WebsiteFieldTester = schemaMatches(schema => schema.renderer === RENDERER_TYPES.websiteField);

export const WebsiteFieldRenderer = withJsonFormsControlProps(
  ({label, data, handleChange, path, visible, required, errors}) => {
    const {t} = useTranslation();
    if (!visible) {
      return null;
    }
    return (
      <TextField
        type="url"
        fullWidth
        label={label}
        required={required}
        error={!!errors}
        helperText={errors ? t("components.customJsonForms.websiteFieldRenderer.error.text") : undefined}
        variant="outlined"
        value={data || ""}
        onChange={event => handleChange(path, event.target.value ? event.target.value : undefined)}
        className="custom-json-forms__renderers__website-field"
      />
    );
  }
);
